import { createFileRoute } from "@tanstack/react-router";

/** Ruta comercial legada. El acceso comercial vive en structura.com.ar. */
export const Route = createFileRoute("/solicitar-trial")({
  component: LegacyTrialRedirect,
});

function LegacyTrialRedirect() {
  if (typeof window !== "undefined") {
    window.location.replace("https://structura.com.ar/");
  }
  return null;
}
